import React from 'react';

const defaultMinimumQuantity = 0;

const QuantitySelector = ({quantity, onChangeQuantity, formatValue, minimumQuantity}) => {

  let minValue = minimumQuantity ? minimumQuantity : defaultMinimumQuantity;
  return (
    <div className="quantity-selector-mobile">
      <div className="button-left"><i className="fa fa-minus" onClick={() => onDecrement()}/></div>
      <div className="text">{(quantity || quantity == 0) && quantity >= minValue ? (formatValue ? formatValue(quantity) : quantity) : minValue}</div>
      <div className="button-right"><i className="fa fa-plus" onClick={() => onIncrement()} /></div>      
    </div>
  );

  function onIncrement() {

    let newQty = quantity ? ++quantity : 1;
    console.log('New quantity', newQty);
    if(onChangeQuantity) onChangeQuantity(newQty)
  }

  function onDecrement() {

    let minValue = minimumQuantity ? minimumQuantity : defaultMinimumQuantity;
    let newQty = quantity > minValue ? --quantity : minValue;
    console.log('New quantity', newQty);
    if(onChangeQuantity) onChangeQuantity(newQty)
  }
};

export default QuantitySelector;



// WEBPACK FOOTER //
// ./src/components/commons/quantity-selector/QuantitySelectorMobile.js